export default __webpack_public_path__ + "static/media/bg_sidebar.9c7b3036.png";